export const groupMessages = {
  emptyGroupWarningTitle: 'No users match the current parameters',
  emptyGroupWarningDescription:
    'The selected parameters return 0 users. Adjust your criteria to include at least one eligible member before saving this group.',
} as const;
